function ArrowRight({ size = "24", color = "#b1272c" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={`${Number(size) - 9}`}
      viewBox="0 0 25.468 16.752"
    >
      <g id="Group_552" data-name="Group 552" transform="translate(0 0.755)">
        <path
          id="Path_1939"
          data-name="Path 1939"
          d="M9733.025,2984h23.614"
          transform="translate(-9733.025 -2976.591)"
          fill="none"
          stroke={color}
          strokeWidth="2"
        />
        <path
          id="Path_1940"
          data-name="Path 1940"
          d="M9745.4,2976.779l8.4,7.286-8.4,7.986"
          transform="translate(-9729.817 -2976.779)"
          fill="none"
          stroke={color}
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}

export default ArrowRight;
